import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const fetchAppAdvancedSurveysSummary = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${__API_URL__}/api/photos/get_app_advanced_surveys_summary/`, {
    params: {
      patientId,
      trialId,
    },
    headers: {
      Authorization: `Token ${token}`,
    },
  });
  return response.data;
};

const useGetAppAdvancedSurveysSummary = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["app-advanced-surveys-summary", patientId, trialId],
    queryFn: () => fetchAppAdvancedSurveysSummary({ patientId, trialId }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
  });
};

export default useGetAppAdvancedSurveysSummary;
